import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  arrowIcon: {
    width: 36,
    height: 36,
  },
});
